import { render, staticRenderFns } from "./Import.vue?vue&type=template&id=6a62c4ed&"
import script from "./Import.vue?vue&type=script&lang=js&"
export * from "./Import.vue?vue&type=script&lang=js&"
import style0 from "./Import.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports